<template>
  <div class="title">
    <h1>Text Walk Admin登録</h1>
  </div>
  <div class="login-box">
    <div class="box-header">
      <h1>SignUp</h1>
    </div>
    <div class="contents">
      <p>IDとパスワードを入力しください。</p>
      <form name="Login" method="post" action="">
        <label for="input-uid">ユーザーID</label>
        <input type="text" id="input-uid" name="uid"  maxlength="32" autocomplete="OFF" v-model="uid"/>
        <p class="error">{{ errors.uid }}</p>
        <label for="input-pwd">パスワード</label>
        <input type="password" id="input-pwd" name="pwd"  maxlength="32" autocomplete="OFF" v-model="pwd"/>
        <p class="error">{{ errors.pwd }}</p>
        <label for="input-pwd">パスワードをもう一度入力してください</label>
        <input type="password" id="input-pwdc" name="pwdc"  maxlength="32" autocomplete="OFF" v-model="pwdc"/>
        <p class="error">{{ errors.pwdc }}</p>
        <button v-if="!valid" :disabled="!valid" type="button">未入力の必須項目があります</button>
        <button v-else-if="valid" type="button" @click="submit">送信</button>
      </form>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
export default {
  name: 'SignupView',
  components: {},
  data: function (){
    return {
      uid: '',
      pwd: '',
      pwdc: '',
    }
  },
  computed:{
    checkUid: function (){
      if(!this.uid){
        return 'ユーザーIDを入力してください'
      } else if(!this.validUid(this.uid)){
        return 'ユーザーIDを英数字で入力してください'
      }
      return '';
    },
    checkPwd: function (){
      if(!this.pwd){
        return 'パスワードを入力してください'
      } else if(!this.validPwd(this.pwd)){
        return 'Passwordは半角英数字で入力してください'
      }
      return '';
    },
    checkPwdc: function (){
      if(!this.pwdc){
        return 'パスワードを入力してください'
      } else if(!this.validPwdc(this.pwd, this.pwdc)){
        return 'Passwordが一致しません'
      }
      return '';
    },
    errors: function (){
      const errors = {
        'uid': this.checkUid,
        'pwd': this.checkPwd,
        'pwdc': this.checkPwdc,
      }
      for (let key in errors) {
        if (errors[key] === '' || errors[key] === null || errors[key] === undefined) {
          delete errors[key];
        }
      }
      return errors;
    },
    valid: function() {
      return !Object.keys(this.errors).length;
    }
  },
  methods: {
    submit: async function(){
      const path = '/signup'
      const params = new URLSearchParams();
      params.append('uid', this.uid)
      params.append('pwd', this.pwd)

      // ログイン認証成功後Topページへ遷移
      let router = this.$router
      await axios.post(path, params)
          .then(function (res) {
            if(res.data.result === true){
              console.log(res.data)
              router.push('/login')
            }
          })
          .catch(function (error) {
            console.log(error)
          })
    },
    validUid: function (uid) {
      const re = /^[a-z0-9]{6,20}$/
      return re.test(uid)
    },
    validPwd: function (pwd) {
      const re = /^[a-zA-Z0-9_+$&@-]{6,20}$/
      return re.test(pwd)
    },
    validPwdc: function (pwd, pwdc) {
      let flag = false;
      if(pwd === pwdc){flag = true}
      return flag
      // const re = /^[a-zA-Z0-9_+$&@-]{6,20}$/
      // return re.test(pwdc)
    }
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
  font-weight: 1000;
  font-size: 1.5rem;
}
.title{
  margin-top: 30px;
  text-align: center;
}
.login-box {
  display: block;
  width: 450px;
  border: solid 1px #2d2f33;
  border-radius: 20px;
  margin: 30px auto auto;
  padding: 20px;
}
#login .box-header {
  background-color: #4077fc;
  border-radius: 20px 20px 0 0;
  color: #ffffff;
  padding: 10px 20px;
}
#login .contents {
  padding: 20px 20px;

}
label {
  display: block;
  margin-top: 15px;
}
input {
  display: block;
  border: solid #5a5e66 2px;
  margin-top: 3px;
  margin-left: 5px;
}
input[type="submit"] {
  border: solid #5a5e66 2px;
  border-radius: 5px;
  padding: 5px;
  margin-top: 20px;
  margin-left: auto;
  margin-right: 20px;
}
.error {
  margin-top: 0.3rem;
  font-size: 0.5rem;
  color: darkred;
}
button {
  border: solid #5a5e66 2px;
  border-radius: 5px;
  padding: 5px;
  margin-top: 20px;
  margin-left: auto;
  margin-right: 20px;
}
</style>